import { toast } from "react-toastify";
import React, { useState } from "react";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import Field from "../input/Field";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";

export default function RegisterFormComponent({ closeModal, changeLogin }) {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        level: UserHelper.UserLevel.User
    });

    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type))
    }

    function register(e) {
        e.preventDefault();
        if (!data.email || !data.password) {
            toast.error(Message.PendingData);
        } else if (data.password !== data.confirmPassword){
            toast.error(Message.PasswordNotMatch);
        }else {
            if (closeModal != undefined) {
                AccountController.CreateUser(data, false, () => closeModal());
            } else {
                AccountController.CreateUser(data, true);
            }
        }
    }

    return (
        <div>
            <form
                className="js-validation-signin"
                onSubmit={(e) => register(e)}>
                <div className="py-3">
                    <Field
                        name="name"
                        onChange={(evt) => handleChange(evt)}
                        title={"Nome"}
                        placeholder={"Nome e sobrenome"}
                        value={data && data.name}
                        type={FieldTypeObj.Text}
                    />
                    <Field
                        name="email"
                        onChange={(evt) => handleChange(evt)}
                        placeholder={"usuario@email.com"}
                        title={"Email"}
                        type={FieldTypeObj.Text}
                        value={data && data.email}
                    />
                    <Field
                        name="password"
                        onChange={(evt) => handleChange(evt)}
                        title={"Senha"}
                        placeholder={"*************"}
                        type={FieldTypeObj.Password}
                        value={data && data.password}
                    />
                    <Field
                        name="confirmPassword"
                        onChange={(evt) => handleChange(evt)}
                        title={"Confirme a Senha"}
                        placeholder={"*************"}
                        type={FieldTypeObj.Password}
                        value={data && data.confirmPassword}
                    />
                    <Field
                        name="phone"
                        onChange={(evt) =>
                            handleChange({
                                target: {
                                    name: evt.target.name,
                                    value: evt.target.value.replace(/[^\d]+/g, ""),
                                },
                            })
                        }
                        title={"Telefone"}
                        value={data && data.phone}
                        type={FieldTypeObj.Mask}
                        mask={"(99) 99999-99999"}
                    />
                </div>
                <div className="form-group">
                    <button
                        type="submit"
                        className="btn btn-block btn-hero-lg btn-hero-warning"
                    >
                        <i
                            className={
                                loading === true
                                    ? "fa fa-circle-notch fa-spin"
                                    : "fa fa-fw fa-sign-in-alt mr-1"
                            }
                        />{" "}
                        Cadastrar
                    </button>
                    <p className="mt-3 mb-0 text-center">
                        <a
                            className="btn btn-sm btn-light d-block d-lg-inline-block mb-1"
                            onClick={() => changeLogin()}
                        >
                            <i className="fa fa-plus text-muted mr-1" /> Já tem
                            conta? Login
                        </a>
                    </p>
                </div>
            </form>
        </div>
    );
}

